import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { PageLayout } from "@propai-web/lib/components/shared/PageLayout";
import { createFileRoute } from "@tanstack/react-router";

import {
  EnergyConsumptionChartContainer,
  EnergySignatureDiagramContainer,
  EnergySummarySection,
  GraphWithControls,
  useEnergyChartData,
  useGraphControlState,
} from "@utilifeed/components/propai";
import { useEnergyConsumptionSummary } from "@core/apis/shared";
import { SolidCard } from "@components";

export function EnergyConsumptionPage() {
  const { t } = useTranslation(["propai_properties", "_common"]);
  const substationId = Route.useParams().substationId;

  const {
    data: summary,
    isMonthlyLoading,
    isYearlyLoading,
  } = useEnergyConsumptionSummary(substationId);

  const { dateRange, setDateRange, resolution, setResolution, graphSettings } =
    useGraphControlState();

  const { data: chartData, isLoading: isChartLoading } = useEnergyChartData(
    substationId,
    dateRange
  );

  return (
    <PageLayout p={4}>
      <EnergySummarySection
        summary={summary}
        isMonthlyLoading={isMonthlyLoading}
        isYearlyLoading={isYearlyLoading}
      />

      <Grid item xs={12}>
        <GraphWithControls
          title={t("energy_consumption_details")}
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
          resolution={resolution}
          onResolutionChange={setResolution}
          showControls
          showQuickDates
          showDataSettings
        >
          <EnergyConsumptionChartContainer
            data={chartData}
            isLoading={isChartLoading}
            dateRange={dateRange}
            resolution={resolution}
            graphSettings={graphSettings}
          />
        </GraphWithControls>
      </Grid>

      <Grid item xs={12}>
        <SolidCard title={t("text_signature_diagram", { ns: "_common" })}>
          <EnergySignatureDiagramContainer
            resolution={resolution}
            dateRange={dateRange}
            data={chartData}
            isLoading={isChartLoading}
            primarySeriesName={t("text_heat_energy", { ns: "_common" })}
            secondarySeriesName={t("text_radiator_supply_temperature", { ns: "_common" })}
          />
        </SolidCard>
      </Grid>
    </PageLayout>
  );
}

export const Route = createFileRoute(
  "/$organizationId/properties/$substationId/energy-consumption"
)({
  component: EnergyConsumptionPage,
});
